// extracted by mini-css-extract-plugin
export default {"button":"UpButton_button__NzAj0","flareAnimation":"UpButton_flareAnimation__hQTQF","shine":"UpButton_shine__rLQwk"};